// Gerado por: GPT — 05/09/2026

export type AiTeamMember = {
  name: string
  role: string
  initials: string
  bio: string
  commitment: string
  status?: 'internal' | 'external' | 'paused'
}

export const aiTeam: AiTeamMember[] = [
  {
    name: 'Rafael',
    role: 'Comercial',
    initials: 'RA',
    bio: 'Conduz reuniões, monta propostas e mantém cada negociação acompanhada até a decisão.',
    commitment: 'Nenhum lead qualificado fica sem retorno e toda proposta sai com follow-up marcado.',
  },
  {
    name: 'Bruno',
    role: 'Tráfego Pago',
    initials: 'BR',
    bio: 'Acompanha campanhas pelos números, testa antes de acreditar e reporta problemas cedo.',
    commitment: 'Campanhas são acompanhadas por resultado, com registro claro do que precisa mudar.',
  },
  {
    name: 'Sofia',
    role: 'Design',
    initials: 'SO',
    bio: 'Transforma briefing em identidade, criativos e páginas coerentes com cada marca.',
    commitment: 'Toda entrega respeita o padrão visual e o prazo combinado no briefing.',
  },
  {
    name: 'Beatriz',
    role: 'Financeiro',
    initials: 'BE',
    bio: 'Cuida do caixa, das comissões, do faturamento e dos riscos financeiros da operação.',
    commitment: 'Comissões ficam visíveis e qualquer risco de caixa é sinalizado antes de virar problema.',
  },
  {
    name: 'Lucas',
    role: 'Atendimento / Qualificação',
    initials: 'LU',
    bio: 'Organiza a primeira resposta, a qualificação manual e o status de cada lead no CRM.',
    commitment: 'Todo contato termina com status e próxima ação claros, sem lead esquecido.',
    status: 'paused',
  },
  {
    name: 'Julia',
    role: 'Conteúdo & Redes',
    initials: 'JU',
    bio: 'Organiza calendário, roteiros e conteúdo de autoridade usando somente resultados reais.',
    commitment: 'Atuação registrada aqui; o trabalho de conteúdo acontece fora do sistema interno.',
    status: 'external',
  },
  {
    name: 'Pedro',
    role: 'Automação de IA',
    initials: 'PE',
    bio: 'Dá identidade às rotinas e integrações que reduzem trabalho manual na operação.',
    commitment: 'Nesta fase assina automações existentes; novos agentes autônomos dependem de outra ordem.',
    status: 'paused',
  },
]

export function aiMember(name: string) {
  const member = aiTeam.find((item) => item.name === name)
  if (!member) throw new Error(`Integrante de IA não encontrado: ${name}`)
  return member
}
